import logger from '../logger.util';

const L = logger('modifyUrl');

const modifyUrl = options => {
  try {
    const { url, delProtocol, addParams } = options || {};

    const u = new URL(url);
    const { protocol, host, pathname: path, search, hash } = u;

    const params = new URLSearchParams(search);
    const entries = Object.entries(addParams || {});

    // eslint-disable-next-line no-restricted-syntax
    for (const [key, val] of entries) {
      params.append(key, val);
    }

    const prot = delProtocol ? '' : `${protocol}//`;
    const result = `${prot}${host}${path}?${params}${hash}`;

    L.debug('()', options, { host, path, hash, search, entries }, '->', result);

    return result;
  } catch (e) {
    L.warn('()', options, '->', e);
    return '';
  }
};

// noinspection JSUnusedGlobalSymbols
export default modifyUrl;
